import { render, staticRenderFns } from "./RouteTab.vue?vue&type=template&id=77c17a10&"
import script from "./RouteTab.vue?vue&type=script&lang=ts&"
export * from "./RouteTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports